import { ArrowUpLeft, Send01 } from "@untitledui/icons";

/** Sidebar invitation to the partners' channel (`ui.partner_channel_url`); black and gold, styles in index.css. On short screens it folds to one row. */
export const ChannelCard = ({ url }: { url: string }) => (
    <a href={url} target="_blank" rel="noopener noreferrer" className="channel-card">
        <span className="channel-card__ring" aria-hidden="true" />
        <span className="channel-card__body">
            <span className="flex items-center gap-3">
                <span className="channel-card__icon" aria-hidden="true">
                    <Send01 className="size-5" />
                </span>
                <span className="channel-card__title text-sm">کانال اختصاصی بازاریاب‌های میزبان‌فا</span>
            </span>
            <span className="channel-card__text text-xs leading-6 text-[#d9d2c1]">
                برای بیشتر شدن فروش و درآمدتان کنارتان هستیم: نکته‌های کار با پنل، ایده‌های فروش و خبرهای تازه، همه یک‌جا.
            </span>
            <span className="channel-card__cta">
                <span className="channel-card__cta-long">عضویت در کانال</span>
                <span className="channel-card__cta-short">عضویت</span>
                <ArrowUpLeft className="size-4" aria-hidden="true" />
            </span>
        </span>
    </a>
);
